// imports
import VimeoPlayer from '@vimeo/player';
import Component from 'minsky-kit/js/components/Component';
// import IframeBg from 'minsky-kit/js/components/IframeBg';
import Ticker from 'minsky-kit/js/managers/Ticker';

// private statics

// class definition

export default class VideoHero extends Component {
    // constructor
    constructor (args = {}, objectName = 'VideoHero') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this._$embed = this.$el.querySelector('.embed-video');
        this._$iframe = this._$embed.querySelector('iframe');
        this._url = this._$iframe.url;

        // init iframe bg
        // this._iframeBg = new IframeBg({ $el: this._$iframe });

        // remove background option
        // this._$iframe.setAttribute('src', `${this._$iframe.getAttribute('src')}?responsive=1&title=false&muted=1&autoplay=1&background=1`);

        // init player on next frame
        Ticker.quick(10, () => {
            this._$iframe.setAttribute('src', `${this._$iframe.getAttribute('src')}?responsive=1&title=false&muted=1&autoplay=1&background=1`);
            // // init player
            this._player = new VimeoPlayer(this._$iframe, {
                background: true,
            });

            this.log('ready', this._player);
            window.player = this._player;
        });
    }

    // methods
    refresh () {
        // this._iframeBg.refresh();
    }

    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
